import React from 'react';

const About: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <h1 className="text-2xl font-bold">Another Page</h1>
    </div>
  );
};

export default About;